var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkrStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1760 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-LKR"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1760,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LKR",
    clipPath: "url(#clip-LKR)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1760,
    height: 1080,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "YardLayout",
    transform: "translate(99 264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BlackCanvas",
    width: 1760,
    height: 1080,
    transform: "translate(-99 -264)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TongueRail",
    transform: "translate(31.441 87.166) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR102A",
    d: "M0,0H69.157L83.992,7.352",
    transform: "translate(520 413.351)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR3840T",
    x2: 180,
    transform: "translate(-30 170.926)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR33T",
    x2: 113.75,
    transform: "translate(509.167 171.083)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR98A",
    d: "M0,0H23.23L157.024,66.506h24.638",
    transform: "translate(74.402 259.759)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR102",
    d: "M0,0H61.555L79.087,8.426",
    transform: "translate(744.792 333.049)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR102B",
    d: "M0,68.723H18.409L154.281,0H176.2",
    transform: "translate(545.566 338.833)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR98B",
    d: "M0,7.943,14.926,0H83.417",
    transform: "translate(191.479 333.049)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR97B",
    d: "M0,0,16.506,7.756H97.29",
    transform: "translate(322.502 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR105AT",
    d: "M0,0H29.06L175.154,69.414h26.635",
    transform: "translate(1079.585 13.881)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR103",
    d: "M0,67.621H24.545L156.911,0h23.668",
    transform: "translate(758.573 259.097)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR100",
    d: "M0,68.148H23.7L161.926,0h22.241",
    transform: "translate(648.646 95.626)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR100BT",
    d: "M0,81.664H33.423L192.62,0H209.9",
    transform: "translate(854.479 7.756)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR104",
    d: "M0,0H21.784L160.449,68.883h19.929",
    transform: "translate(896.331 177.739)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TrackCircuit",
    transform: "translate(74.779 87.889) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TC34_36T",
    className: "tooltip cursorArrow ",
    transform: "translate(0 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC34_36TLine",
    x2: 135.417,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC34_36TName",
    transform: "translate(67.708 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC34_36TRectangle",
    width: 56.875,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC34_36TLabel",
    transform: "translate(7.438 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                34/36T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC038T",
    className: "tooltip cursorArrow ",
    transform: "translate(109.688 163.327)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC038TLine",
    x2: 155.729,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC038TName",
    transform: "translate(52.813 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC038TRectangle",
    width: 37.347,
    height: 13.611,
    transform: "translate(3.14 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC038TLabel",
    transform: "translate(6.314 11.8)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                038T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC033T",
    className: "tooltip cursorArrow ",
    transform: "translate(270.833 163.327)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC033TLine",
    x2: 189.583,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC033TName",
    transform: "translate(73.125 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC033TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC033TLabel",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                033T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC100AT",
    className: "tooltip cursorArrow ",
    transform: "translate(585 163.327)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC100ATLine",
    x2: 167.917,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC100ATName",
    transform: "translate(92.083 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC100ATRectangle",
    width: 48.75,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC100ATLabel",
    transform: "translate(5.375 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                100AT\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC104AT",
    className: "tooltip cursorArrow ",
    transform: "translate(758.333 163.327)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC104ATLine",
    x2: 270.833,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC104ATName",
    transform: "translate(186.875 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC104ATRectangle",
    width: 48.75,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC104ATLabel",
    transform: "translate(5.375 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                104AT\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC041T",
    className: "tooltip cursorArrow ",
    transform: "translate(1034.583 163.327)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC041TLine",
    x2: 222.083,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC041TName",
    transform: "translate(100.208 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC041TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC041TLabel",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                041T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC41T",
    className: "tooltip cursorArrow ",
    transform: "translate(1262.083 163.327)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC41TLine",
    x2: 159.792,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC41TName",
    transform: "translate(59.583 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC41TRectangle",
    width: 32.5,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC41TLabel",
    transform: "translate(5.25 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                41T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC100BT",
    className: "tooltip cursorArrow ",
    transform: "translate(667.604 81.664)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC100BTLine",
    x2: 138.125,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC100BTName",
    transform: "translate(31.146 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC100BTRectangle",
    width: 48.75,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC100BTLabel",
    transform: "translate(5.375 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                100BT\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC101AT",
    className: "tooltip cursorArrow ",
    transform: "translate(863.958 81.664)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC101ATLine",
    x2: 161.146,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC101ATName",
    transform: "translate(65 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC101ATRectangle",
    width: 48.75,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC101ATLabel",
    transform: "translate(5.375 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                101AT\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC105BT",
    className: "tooltip cursorArrow ",
    transform: "translate(1030.521 81.664)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC105BTLine",
    x2: 387.292,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC105BTName",
    transform: "translate(79.896 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC105BTRectangle",
    width: 48.75,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC105BTLabel",
    transform: "translate(5.375 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                105BT\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC040T",
    className: "tooltip cursorArrow ",
    transform: "translate(381.875 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC040TLine",
    x2: 170.625,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC040TName",
    transform: "translate(70.417 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC040TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC040TLabel",
    transform: "translate(4.669 12.371)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                040T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC035_040T",
    className: "tooltip cursorArrow ",
    transform: "translate(557.917 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC035_040TLine",
    x2: 155.729,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC035_040TName",
    transform: "translate(46.042 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC035_040TRectangle",
    width: 65.231,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC035_040TLabel",
    transform: "translate(4.116 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                035/040T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC035T",
    className: "tooltip cursorArrow ",
    transform: "translate(719.063 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC035TLine",
    x2: 169.271,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC035TName",
    transform: "translate(58.229 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC035TRectangle",
    width: 36.712,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC035TLabel",
    transform: "translate(3.856 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                035T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC35T",
    className: "tooltip cursorArrow ",
    transform: "translate(893.75 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC35TLine",
    x2: 92.083,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC35TName",
    transform: "translate(24.375 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC35TRectangle",
    width: 24.862,
    height: 13.611,
    transform: "translate(7.638 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC35TLabel",
    transform: "translate(9.069 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                35T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC105AT",
    className: "tooltip cursorArrow ",
    transform: "translate(1026.458 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC105ATLine",
    x2: 106.979,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC105ATName",
    transform: "translate(54.167 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC105ATRectangle",
    width: 45.796,
    height: 13.611,
    transform: "translate(1.477 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC105ATLabel",
    transform: "translate(5.375 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                105AT\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC045T",
    className: "tooltip cursorArrow ",
    transform: "translate(1138.854 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC045TLine",
    x2: 81.25,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC045TName",
    transform: "translate(17.604 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC045TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC045TLabel",
    transform: "translate(8.685 11.813)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                045T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC45T",
    className: "tooltip cursorArrow ",
    transform: "translate(1225.521 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC45TLine",
    x2: 69.063,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC45TName",
    transform: "translate(20.313 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC45TRectangle",
    width: 30.5,
    height: 13.611,
    transform: "translate(1 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC45TLabel",
    transform: "translate(5.25 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                45T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC46T",
    className: "tooltip cursorArrow ",
    transform: "translate(1300 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC46TLine",
    x2: 66.354,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC46TName",
    transform: "translate(16.25 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC46TRectangle",
    width: 32.5,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC46TLabel",
    transform: "translate(5.25 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                46T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TCC46T",
    className: "tooltip cursorArrow ",
    transform: "translate(1371.771 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC46TLine",
    x2: 62.292,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCC46TName",
    transform: "translate(9.479 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCC46TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC46TLabel",
    transform: "translate(6.667 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                C46T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC034T",
    className: "tooltip cursorArrow ",
    transform: "translate(140.833 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC034TLine",
    x2: 119.167,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC034TName",
    transform: "translate(56.875 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC034TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC034TLabel",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                034T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC037T",
    className: "tooltip cursorArrow ",
    transform: "translate(265.417 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC037TLine",
    x2: 89.375,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC037TName",
    transform: "translate(18.958 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC037TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC037TLabel",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                037T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC37T",
    className: "tooltip cursorArrow ",
    transform: "translate(360.208 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC37TLine",
    x2: 262.708,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC37TName",
    transform: "translate(148.958 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC37TRectangle",
    width: 37.917,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC37TLabel",
    transform: "translate(7.958 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                37T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC37T1",
    className: "tooltip cursorArrow ",
    transform: "translate(628.333 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC37T1Line",
    x2: 154.375,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC37T1Name",
    transform: "translate(51.458 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC37T1Rectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC37T1Label",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                37T1\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC103T",
    className: "tooltip cursorArrow ",
    transform: "translate(788.125 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC103TLine",
    x2: 134.063,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC103TName",
    transform: "translate(24.375 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC103TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC103TLabel",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                103T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC42T",
    className: "tooltip cursorArrow ",
    transform: "translate(927.604 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC42TLine",
    x2: 147.604,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC42TName",
    transform: "translate(14.896 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC42TRectangle",
    width: 37.917,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC42TLabel",
    transform: "translate(7.97 9.652)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                42T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC44T2",
    className: "tooltip cursorArrow ",
    transform: "translate(1080.625 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC44T2Line",
    x2: 86.667,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC44T2Name",
    transform: "translate(21.667 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC44T2Rectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC44T2Label",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                44T2\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC44T1",
    className: "tooltip cursorArrow ",
    transform: "translate(1172.708 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC44T1Line",
    x2: 77.188,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC44T1Name",
    transform: "translate(21.667 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC44T1Rectangle",
    d: "M0,0H37.755V13.611H0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC44T1Label",
    transform: "translate(4.378 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                44T1\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC44T",
    className: "tooltip cursorArrow ",
    transform: "translate(1255.313 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC44TLine",
    x2: 62.292,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC44TName",
    transform: "translate(14.896 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC44TRectangle",
    width: 32.5,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC44TLabel",
    transform: "translate(5.25 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                44T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TCC44T",
    className: "tooltip cursorArrow ",
    transform: "translate(1323.021 244.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC44TLine",
    x2: 97.5,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCC44TName",
    transform: "translate(33.854 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCC44TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC44TLabel",
    transform: "translate(6.667 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                C44T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC036T",
    className: "tooltip cursorArrow ",
    transform: "translate(236.979 325.293)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC036TLine",
    x2: 113.75,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC036TName",
    transform: "translate(36.563 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC036TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC036TLabel",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                036T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC036T1",
    className: "tooltip cursorArrow ",
    transform: "translate(356.146 325.293)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC036T1Line",
    x2: 113.75,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC036T1Name",
    transform: "translate(33.854 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC036T1Rectangle",
    width: 51.458,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC036T1Label",
    transform: "translate(7.229 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                036T1\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC036T2",
    className: "tooltip cursorArrow ",
    transform: "translate(475.313 325.293)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC036T2Line",
    x2: 102.917,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC036T2Name",
    transform: "translate(25.729 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC036T2Rectangle",
    width: 51.458,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC036T2Label",
    transform: "translate(7.229 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                036T2\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC33T",
    className: "tooltip cursorArrow ",
    transform: "translate(383.229 176.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC33TLine",
    d: "M0,68.885H23.034L158.905,0h23.6",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC33TName",
    transform: "translate(74.479 27.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC33TRectangle",
    width: 32.5,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC33TLabel",
    transform: "translate(5.25 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                33T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC38_40T",
    className: "tooltip cursorArrow ",
    transform: "translate(15.512 13.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC38_40TLine",
    d: "M0,150.4H19.7L320.322,0h21.667",
    transform: "translate(0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC38_40TName",
    transform: "translate(158.123 59.326)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC38_40TRectangle",
    width: 54.167,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC38_40TLabel",
    transform: "translate(6.083 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                38/40T\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TC102T",
    className: "tooltip cursorArrow ",
    transform: "translate(583.646 325.293)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC102TLine",
    x2: 112.396,
    transform: "translate(0 6.805)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC102TName",
    transform: "translate(12.188 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC102TRectangle",
    width: 43.333,
    height: 13.611,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC102TLabel",
    transform: "translate(7.167 11.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                102T\n              "))))), /*#__PURE__*/React.createElement("g", {
    id: "Separator",
    transform: "translate(26.03 88.145) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SPUPAXC",
    d: "M0,13.611H14.6L14.9,0",
    transform: "translate(-15.104 176.781) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SPDN1AXC",
    d: "M0,13.611H14.6L14.9,0",
    transform: "translate(58.229 258.601) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SP102A",
    d: "M14.9,0H.3L0,13.611",
    transform: "translate(518.646 405.596)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SP100B",
    d: "M14.9,0H.3L0,13.611",
    transform: "translate(710.26 81.664)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SPC44",
    d: "M0,0H14.6l.3,13.611",
    transform: "translate(1461.823 244.991)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SP105B",
    d: "M0,0H14.6l.3,13.611",
    transform: "translate(1459.115 81.664)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SPC46",
    d: "M0,0H14.6l.3,13.611",
    transform: "translate(1475.365 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SP41",
    d: "M0,0H14.6l.3,13.611",
    transform: "translate(1463.177 163.327)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "PointMachine",
    transform: "translate(53.013 68.948) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM98B",
    className: "tooltip cursorArrow ",
    transform: "translate(211.25 319.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM98BHr",
    transform: "translate(32.5 4.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM98BHr1",
    d: "M17.059,20.2C7.886,16.168,3.076,12.5,1.1,9.427-4.182,1.2,10.914-2.739,17.059,2.12,23.2-2.739,38.3,1.2,33.014,9.427,31.042,12.5,26.231,16.168,17.059,20.2Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM98BHr2",
    d: "M0,5.357H7.9L10.52,0l4.855,9.464,3.3-4.107H29.392",
    transform: "translate(2.386 4.315)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM98BIcon",
    transform: "translate(-3.919 -4.657)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM98BLabel",
    transform: "translate(18.047 -2.906)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              98B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM98A",
    className: "tooltip cursorArrow ",
    transform: "translate(54.167 244.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM98AHr",
    transform: "translate(24.266 -14.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM98AHr1",
    d: "M16.452,19.69C7.606,15.758,2.966,12.182,1.064,9.188c-5.1-8.022,9.462-11.858,15.388-7.122,5.926-4.735,20.486-.9,15.388,7.122C29.938,12.182,25.3,15.758,16.452,19.69Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM98AHr2",
    d: "M0,5.357H7.574L10.086,0,14.74,9.464,17.9,5.357H28.179",
    transform: "translate(2.386 4.109)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM98AIcon",
    transform: "translate(-0.912 -5.573)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM98ALabel",
    transform: "translate(-30.958 -0.801)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              98A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM97A",
    className: "tooltip cursorArrow ",
    transform: "translate(0 168.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM97AHr",
    transform: "translate(-8.364 42.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM97AHr1",
    d: "M16.684,23.517C7.713,18.821,3.008,14.55,1.079,10.975c-5.169-9.581,9.6-14.163,15.606-8.507,6.01-5.656,20.775-1.074,15.606,8.507C30.361,14.55,25.656,18.821,16.684,23.517Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM97AHr2",
    d: "M0,5.357H7.7L10.252,0l4.731,9.464L18.2,5.357H28.643",
    transform: "translate(2.386 5.647)",
    fill: "rgba(0,0,0,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM97AIcon",
    transform: "translate(34.198 25.092)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM97ALabel",
    transform: "translate(4.38 38.925)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              97A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM97B",
    className: "tooltip cursorArrow ",
    transform: "translate(325.787 -10.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM97BHr",
    transform: "translate(52.995 -7.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM97BHr1",
    d: "M17.187,24.426C7.946,19.549,3.1,15.112,1.111,11.4-4.214,1.447,11-3.312,17.187,2.563c6.191-5.875,21.4-1.115,16.076,8.836C31.275,15.112,26.429,19.549,17.187,24.426Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM97BHr2",
    d: "M0,5.357H7.969L10.612,0l4.9,9.464,3.328-4.107H29.649",
    transform: "translate(2.386 6.013)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM97BIcon",
    transform: "translate(29.792 6.805)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM97BLabel",
    transform: "translate(-3.044 23.923)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              97B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM99B",
    className: "tooltip cursorArrow ",
    transform: "translate(563.333 198.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM99BHr",
    transform: "translate(23.907 20.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM99BHr1",
    d: "M13.621,21.52C6.3,17.223,2.456,13.314.881,10.043-3.34,1.275,8.715-2.918,13.621,2.258c4.907-5.176,16.961-.983,12.741,7.785C24.786,13.314,20.945,17.223,13.621,21.52Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM99BHr2",
    d: "M0,5.357H6.052L8.059,0l3.719,9.464,2.528-4.107h8.211",
    transform: "translate(2.386 4.845)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM99BIcon",
    transform: "translate(1.02 3.966)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM99BLabel",
    transform: "translate(30.049 12.552)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              99B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM99A",
    className: "tooltip cursorArrow ",
    transform: "translate(365.625 274.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM99AHr",
    transform: "translate(6.418 10.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM99AHr1",
    d: "M14.113,21.478C6.525,17.189,2.545,13.288.912,10.023c-4.373-8.75,8.117-12.935,13.2-7.769,5.084-5.165,17.573-.981,13.2,7.769C25.681,13.288,21.7,17.189,14.113,21.478Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM99AHr2",
    d: "M0,5.357H6.316L8.411,0l3.881,9.464L14.93,5.357H23.5",
    transform: "translate(2.386 4.828)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM99AIcon",
    transform: "translate(40.625 0)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM99ALabel",
    transform: "translate(68.324 17.64)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              99A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM100A",
    className: "tooltip cursorArrow ",
    transform: "translate(620.208 146.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM100AHr",
    transform: "translate(32.5 -5.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM100AHr1",
    d: "M16.389,21.475C7.577,17.187,2.955,13.286,1.06,10.022-4.018,1.273,10.486-2.911,16.389,2.253c5.9-5.165,20.407-.981,15.329,7.768C29.823,13.286,25.2,17.187,16.389,21.475Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM100AHr2",
    d: "M0,5.357H7.54L10.04,0l4.633,9.464,3.149-4.107h10.23",
    transform: "translate(2.386 4.827)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM100AIcon",
    transform: "translate(7.349 3.766)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM100ALabel",
    transform: "translate(-16.916 -0.491)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              100A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM100B",
    className: "tooltip cursorArrow ",
    transform: "translate(785.417 117.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM100BHr",
    transform: "translate(37.475 2.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM100BHr1",
    d: "M13.18,22.4C6.093,17.926,2.376,13.858.852,10.452-3.231,1.327,8.432-3.037,13.18,2.35c4.748-5.387,16.411-1.023,12.328,8.1C23.984,13.858,20.267,17.926,13.18,22.4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM100BHr2",
    d: "M0,5.357H5.815L7.743,0l3.573,9.464,2.428-4.107h7.889",
    transform: "translate(2.386 5.198)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM100BIcon",
    transform: "translate(5.878 2.583)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM100BLabel",
    transform: "translate(-25.334 38.987)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              100B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM101A",
    className: "tooltip cursorArrow ",
    transform: "translate(796.443 67.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM101AHr",
    transform: "translate(0 0.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM100BHr1-2",
    "data-name": "PM100BHr1",
    d: "M14.235,22.254C6.581,17.811,2.567,13.769.92,10.385c-4.41-9.067,8.187-13.4,13.315-8.05,5.128-5.352,17.725-1.016,13.315,8.05C25.9,13.769,21.889,17.811,14.235,22.254Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM100BHr2-2",
    "data-name": "PM100BHr2",
    d: "M0,5.357H6.382L8.5,0,12.42,9.464l2.665-4.107h8.659",
    transform: "translate(2.386 5.14)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM101AIcon",
    transform: "translate(44.337 10.179)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM101ALabel",
    transform: "translate(35.208 6)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              101A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM101B",
    className: "tooltip cursorArrow ",
    transform: "translate(1012.001 -16.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM101BHr",
    transform: "translate(40.625 5.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM101BHr1",
    d: "M18.958,16.333C8.765,13.072,3.418,10.1,1.226,7.622-4.648.968,12.129-2.214,18.958,1.714,25.787-2.214,42.565.968,36.691,7.622,34.5,10.1,29.152,13.072,18.958,16.333Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM101BHr2",
    d: "M0,5.357H8.921L11.88,0l5.482,9.464,3.726-4.107h12.1",
    transform: "translate(2.386 2.76)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM101BIcon",
    transform: "translate(8.125 10.888)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM101BLabel",
    transform: "translate(-4.974 1.007)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              101B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM105A",
    className: "tooltip cursorArrow ",
    transform: "translate(1021.966 37.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM105AHr",
    transform: "translate(0 -0.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM105AHr1",
    d: "M13.005,17.915C6.012,14.338,2.345,11.084.841,8.36c-4.029-7.3,7.48-10.789,12.164-6.481C17.69-2.429,29.2,1.062,25.17,8.36,23.665,11.084,20,14.338,13.005,17.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM105AHr2",
    d: "M0,5.357H5.721L7.618,0l3.516,9.464,2.389-4.107h7.762",
    transform: "translate(2.386 3.396)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM105AIcon",
    transform: "translate(43.333 0)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM105ALabel",
    transform: "translate(10.397 26.424)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              105A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM105B",
    className: "tooltip cursorArrow ",
    transform: "translate(1232.292 76.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM105BHr",
    transform: "translate(37.917 10.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM105BHr1",
    d: "M18.958,16.333C8.765,13.072,3.418,10.1,1.226,7.622-4.648.968,12.129-2.214,18.958,1.714,25.787-2.214,42.565.968,36.691,7.622,34.5,10.1,29.152,13.072,18.958,16.333Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM105BHr2",
    d: "M0,5.357H8.921L11.88,0l5.482,9.464,3.726-4.107h12.1",
    transform: "translate(2.386 2.76)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM105BIcon",
    transform: "translate(3.527 -4.136)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM105BLabel",
    transform: "translate(-11.932 -7.063)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              105B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM104A",
    className: "tooltip cursorArrow ",
    transform: "translate(826.042 163.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM104AHr",
    transform: "translate(0 -1.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM104AHr1",
    d: "M15.8,20.666c-8.5-4.126-12.953-7.88-14.78-11.022C-3.874,1.225,10.11-2.8,15.8,2.168c5.692-4.97,19.676-.944,14.78,7.476C28.755,12.786,24.3,16.539,15.8,20.666Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM104AHr2",
    d: "M0,5.357H7.225L9.62,0,14.06,9.464l3.017-4.107h9.8",
    transform: "translate(2.386 4.501)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM104AIcon",
    transform: "translate(43.707 -5.716)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM104ALabel",
    transform: "translate(12.686 -5.71)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              104A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM104B",
    className: "tooltip cursorArrow ",
    transform: "translate(1026.458 238.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM104BHr",
    transform: "translate(37.917 9.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM104BHr1",
    d: "M18.958,16.333C8.765,13.072,3.418,10.1,1.226,7.622-4.648.968,12.129-2.214,18.958,1.714,25.787-2.214,42.565.968,36.691,7.622,34.5,10.1,29.152,13.072,18.958,16.333Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM104BHr2",
    d: "M0,5.357H8.921L11.88,0l5.482,9.464,3.726-4.107h12.1",
    transform: "translate(2.386 2.76)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM104BIcon",
    transform: "translate(7.059 -3.267)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM104BLabel",
    transform: "translate(32.284 -7.266)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              104B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM103B",
    className: "tooltip cursorArrow ",
    transform: "translate(845 243.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM103BHr",
    transform: "translate(0 -2.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM103BHr1",
    d: "M16.267,20.661C7.521,16.535,2.933,12.783,1.052,9.642-3.988,1.224,10.408-2.8,16.267,2.168c5.86-4.969,20.256-.944,15.216,7.474C29.6,12.783,25.014,16.535,16.267,20.661Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM103BHr2",
    d: "M0,5.357H7.475L9.953,0l4.593,9.464,3.122-4.107H27.809",
    transform: "translate(2.386 4.499)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM103BIcon",
    transform: "translate(49.821 -2.746)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM103BLabel",
    transform: "translate(13.671 -2.766)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              103B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM103A",
    className: "tooltip cursorArrow ",
    transform: "translate(731.25 319.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM103AHr",
    transform: "translate(60.347 11.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM102BHr1",
    d: "M17.4,20.649C8.046,16.526,3.138,12.775,1.125,9.636-4.267,1.224,11.134-2.8,17.4,2.167c6.269-4.966,21.67-.943,16.278,7.469C31.669,12.775,26.761,16.526,17.4,20.649Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM102BHr2",
    d: "M0,4.39H8.347L11.114,0l5.129,7.755L19.729,4.39H31.053",
    transform: "translate(1.877 4.672)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM103AIcon",
    transform: "translate(4.201 -3.598)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM103ALabel",
    transform: "translate(29.426 -7.597)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              103A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM102A",
    className: "tooltip cursorArrow ",
    transform: "translate(479.375 397.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM102AHr",
    transform: "translate(0 -3.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM102AHr1",
    d: "M16.263,24.961C7.519,19.977,2.932,15.443,1.052,11.648-3.987,1.479,10.4-3.384,16.263,2.619c5.858-6,20.251-1.14,15.212,9.029C29.594,15.443,25.008,19.977,16.263,24.961Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM102AHr2",
    d: "M0,5.357H7.472L9.95,0l4.592,9.464,3.121-4.107H27.8",
    transform: "translate(2.386 6.227)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM102AIcon",
    transform: "translate(42.406 -3.001)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM102ALabel",
    transform: "translate(11.408 -7.294)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              102A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM102B",
    className: "tooltip cursorArrow ",
    transform: "translate(671.667 360.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM102BHr",
    transform: "translate(41.607 -0.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM102BHr1-2",
    "data-name": "PM102BHr1",
    d: "M15.825,22.069C7.316,17.663,2.853,13.654,1.023,10.3c-4.9-8.991,9.1-13.291,14.8-7.983,5.7-5.308,19.7-1.008,14.8,7.983C28.8,13.654,24.334,17.663,15.825,22.069Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM102BHr2-2",
    "data-name": "PM102BHr2",
    d: "M0,4.939H7.265L9.674,0l4.464,8.725,3.034-3.786h9.856",
    transform: "translate(2.243 5.189)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM102BIcon",
    transform: "translate(6.126 -0.262)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM102BLabel",
    transform: "translate(-9.552 38.818)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              102B\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "Signal",
    transform: "translate(139.636 60.328) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGC42",
    className: "tooltip cursorArrow ",
    transform: "translate(988.542 282.42)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC42Label",
    transform: "translate(0.938 19.712)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-42\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC42Aspect",
    transform: "translate(5.475 8.569)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1",
    y2: 16.333,
    transform: "translate(39.189 -0.696)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2",
    x2: 21.002,
    transform: "translate(18.187 15.637)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3",
    x2: 14,
    transform: "translate(-8.679 15.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS42",
    className: "tooltip cursorArrow ",
    transform: "translate(945.211 292.203)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SG42Label",
    transform: "translate(6.656 26.909)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-42\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS42Aspect2",
    transform: "translate(1.017 -3.176)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS42Aspect1",
    transform: "translate(18.105 -3.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SG42Route",
    className: "tooltip cursorArrow ",
    transform: "translate(923.542 289.906)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SGS42RouteBAspect",
    y1: 4.305,
    x2: 6.771,
    transform: "translate(15.288 9.114)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SGS42RouteCAspect",
    x1: 8.125,
    y1: 5.444,
    transform: "translate(13.542 2.722)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SGS42RouteBLabel",
    transform: "translate(10.216 20.9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              B\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SGS42RouteCLabel",
    transform: "translate(8.542 0.653)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              C\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SGS42RouteALabel",
    transform: "translate(-0.01 10.444)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              A{\" \"}\n            ")), /*#__PURE__*/React.createElement("line", {
    id: "SGS42RouteAAspect",
    x2: 13.542,
    transform: "translate(8.123 8.625)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGC35",
    className: "tooltip cursorArrow ",
    transform: "translate(834.167 30.624) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC35Label",
    transform: "translate(44.561 42.94) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-35\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC35Aspect",
    transform: "translate(8.779 7.969)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-2",
    "data-name": "POLES",
    transform: "translate(-0.999 -0.211)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-2",
    "data-name": "POLES1",
    x1: 0.137,
    y2: 17.042,
    transform: "translate(39.276 -1.709)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "POLES2-2",
    "data-name": "POLES2",
    d: "M0,0,4.612.008,16.4.028",
    transform: "translate(22.878 15.212)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-2",
    "data-name": "POLES3",
    x2: 5.5,
    transform: "translate(4.325 15.172)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS35",
    className: "tooltip cursorArrow ",
    transform: "translate(834.167 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS35Aspect1",
    transform: "translate(13.34 7.597)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS35Aspect2",
    transform: "translate(-3.701 7.508)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG35Label",
    transform: "translate(4.453 -1.005)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-35\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGC40",
    className: "tooltip cursorArrow ",
    transform: "translate(330.417 38.11)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC40Label",
    transform: "translate(2.708 19.735)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-40\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC40Aspect",
    transform: "translate(5.431 8.92)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-3",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-3",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(37.917 -0.511)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-3",
    "data-name": "POLES2",
    y1: 0.236,
    x2: 19.7,
    transform: "translate(18.217 15.652)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-3",
    "data-name": "POLES3",
    y1: 0.115,
    x2: 10.199,
    transform: "translate(-4.783 15.652)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS40",
    className: "tooltip cursorArrow ",
    transform: "translate(287.083 47.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS40Aspect1",
    transform: "translate(21.677 -1.887)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS40Aspect2",
    transform: "translate(4.588 -1.976)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG40Label",
    transform: "translate(-8.548 29.091)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-40\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGC33",
    className: "tooltip cursorArrow ",
    transform: "translate(425.208 193.951) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC33Label",
    transform: "translate(40.866 40.4) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-33\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC33Aspect",
    transform: "translate(8.429 9.23)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-4",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-4",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(37.917 -0.681)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-4",
    "data-name": "POLES2",
    x2: 16.25,
    transform: "translate(21.667 15.652)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-4",
    "data-name": "POLES3",
    x2: 8.225,
    transform: "translate(0 15.594)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS33",
    className: "tooltip cursorArrow ",
    transform: "translate(468.542 183.743) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS33Aspect1",
    transform: "translate(26.793 -2.928)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS33Aspect2",
    transform: "translate(9.705 -3.017)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG33Label",
    transform: "translate(39.648 19.8) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-33\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGS33Route",
    className: "tooltip cursorArrow ",
    transform: "translate(478.169 180.526) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SGS33RouteBAspect",
    y1: 6.165,
    x2: 9.095,
    transform: "translate(10.155 1.737)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SGS33RouteBLabel",
    transform: "translate(7.666 10.426) rotate(180)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              B\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SGS33RouteALabel",
    transform: "translate(3 1) rotate(180)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              A{\" \"}\n            ")), /*#__PURE__*/React.createElement("line", {
    id: "SGS33RouteAAspect",
    x2: 13.542,
    transform: "translate(5.708 1.278)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGC37",
    className: "tooltip cursorArrow ",
    transform: "translate(287.422 275.455) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC37Label",
    transform: "translate(80.324 39.815) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-37\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC37Aspect",
    transform: "translate(41.266 8.611)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-5",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES3-5",
    "data-name": "POLES3",
    x2: 5.417,
    transform: "translate(35.838 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "POLES1-5",
    "data-name": "POLES1",
    d: "M78.335,14.812V9.432H0V0H24.164",
    transform: "translate(78.335 14.812) rotate(-180)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS37",
    className: "tooltip cursorArrow ",
    transform: "translate(297.917 266.087) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SG37Label",
    transform: "translate(38.124 20.792) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-37\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect2",
    transform: "translate(12.228 -3.004)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect1",
    transform: "translate(29.317 -2.914)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SG40Route",
    className: "tooltip cursorArrow ",
    transform: "translate(317.167 261.921) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SGS33RouteCAspect",
    d: "M0,4.305,11,0",
    transform: "translate(20.876 4.632) rotate(-13)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SGS33RouteCLabel",
    transform: "translate(20.133 10.818) rotate(180)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              C\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SGS33RouteBLabel-2",
    "data-name": "SGS33RouteBLabel",
    transform: "translate(15.145 -2.447) rotate(180)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              B{\" \"}\n            ")), /*#__PURE__*/React.createElement("line", {
    id: "SGS33RouteBAspect-2",
    "data-name": "SGS33RouteBAspect",
    x2: 11,
    transform: "translate(20.231 1.098)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGC38",
    className: "tooltip cursorArrow ",
    transform: "translate(43.333 201.223)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC38Label",
    transform: "translate(18.765 19.563)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-38\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC38Aspect",
    transform: "translate(5.429 9.066)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-6",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "POLES1-6",
    "data-name": "POLES1",
    d: "M.032-1.919,0,4.27H48.556V15.48l-35.336.261",
    transform: "translate(5.417 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-6",
    "data-name": "POLES3",
    x2: 9.971,
    y2: 0.325,
    transform: "translate(-4.554 15.154)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS38",
    className: "tooltip cursorArrow ",
    transform: "translate(43.333 229.639) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SG38Label",
    transform: "translate(51.86 -5.978) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-38\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS38Aspect2",
    transform: "translate(4.651 4.956)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS38Aspect1",
    transform: "translate(21.739 5.046)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC34",
    className: "tooltip cursorArrow ",
    transform: "translate(94.792 282.42)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC34Label",
    transform: "translate(36.302 8.455)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              C-34\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC34Aspect",
    transform: "translate(5.429 9.215)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-7",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-7",
    "data-name": "POLES1",
    x1: 0.03,
    y2: 17.422,
    transform: "translate(32.562 -2)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-5",
    "data-name": "POLES2",
    x2: 14,
    y2: 0.073,
    transform: "translate(18.562 15.349)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-7",
    "data-name": "POLES3",
    x2: 5.417,
    transform: "translate(0 15.652)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS34",
    className: "tooltip cursorArrow ",
    transform: "translate(94.792 311.303) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SG34Label",
    transform: "translate(30.844 -7.995) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-34\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS34Aspect2",
    transform: "translate(0.021 3.975)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS34Aspect1",
    transform: "translate(19.125 3.075)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC36",
    className: "tooltip cursorArrow ",
    transform: "translate(167.917 362.722)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC36Label",
    transform: "translate(15.434 21.805)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-36\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC36Aspect",
    transform: "translate(5.432 8.569)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-8",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-8",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(32.5 -0.61)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-6",
    "data-name": "POLES2",
    x2: 14.483,
    y2: 0.224,
    transform: "translate(18.017 15.428)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-8",
    "data-name": "POLES3",
    x2: 7,
    transform: "translate(-1.483 15.437)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS36",
    className: "tooltip cursorArrow ",
    transform: "translate(167.917 393.18) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SG36Label",
    transform: "translate(43.391 -4.775) rotate(180)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-36\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS36Aspect2",
    transform: "translate(1.016 6.366)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS36Aspect1",
    transform: "translate(18.104 6.456)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC44",
    className: "tooltip cursorArrow ",
    transform: "translate(1224.167 282.42)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC44Label",
    transform: "translate(5.401 22.735)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-44\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC44Aspect",
    transform: "translate(8.425 9.911)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-9",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-9",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(39.283 0.133)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-7",
    "data-name": "POLES2",
    x2: 18,
    y2: 0.094,
    transform: "translate(21.198 16.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-9",
    "data-name": "POLES3",
    x2: 15,
    transform: "translate(-6.302 16.173)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS44",
    className: "tooltip cursorArrow ",
    transform: "translate(1180.833 292.628)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SG44Label",
    transform: "translate(0.661 25.878)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-44\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS44Aspect2",
    transform: "translate(2.782 -3.167)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS44Aspect1",
    transform: "translate(19.87 -3.077)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS43",
    className: "tooltip cursorArrow ",
    transform: "translate(1098.396 245.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POLES-10",
    "data-name": "POLES",
    transform: "translate(0 15.652)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-10",
    "data-name": "POLES1",
    y2: 14.972,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-8",
    "data-name": "POLES2",
    x1: 18.958,
    transform: "translate(0.078 0.1)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS43Aspect1",
    transform: "translate(19.159 7.197)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS43Aspect2",
    transform: "translate(35.695 7.284)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0A8.5,8.5,0,1,1,0,8.5,8.5,8.5,0,0,1,8.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 1.000001907348633 C 4.364489555358887 1.000001907348633 1 4.364490509033203 1 8.500000953674316 C 1 12.63551139831543 4.364489555358887 16 8.5 16 C 12.6355094909668 16 16 12.63551139831543 16 8.500000953674316 C 16 4.364490509033203 12.6355094909668 1.000001907348633 8.5 1.000001907348633 M 8.5 1.9073486328125e-06 C 13.19441986083984 1.9073486328125e-06 17 3.805581092834473 17 8.500000953674316 C 17 13.19442081451416 13.19441986083984 17 8.5 17 C 3.805580139160156 17 0 13.19442081451416 0 8.500000953674316 C 0 3.805581092834473 3.805580139160156 1.9073486328125e-06 8.5 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#6c7091"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS43Label",
    transform: "translate(9.709 0.606)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              DS-43\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGS41",
    className: "tooltip cursorArrow ",
    transform: "translate(1179.479 163.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POLES-11",
    "data-name": "POLES",
    transform: "translate(0.017 16.305)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-11",
    "data-name": "POLES1",
    y2: 14.972,
    transform: "translate(-0.487 -0.251)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-9",
    "data-name": "POLES2",
    x1: 20.804,
    y1: 0.15,
    transform: "translate(-0.488 -0.142)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS41Aspect1",
    transform: "translate(20.455 8.076)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS41Aspect2",
    transform: "translate(37.544 8.165)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0A8.5,8.5,0,1,1,0,8.5,8.5,8.5,0,0,1,8.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 1.000001907348633 C 4.364489555358887 1.000001907348633 1 4.364490509033203 1 8.500000953674316 C 1 12.63551139831543 4.364489555358887 16 8.5 16 C 12.6355094909668 16 16 12.63551139831543 16 8.500000953674316 C 16 4.364490509033203 12.6355094909668 1.000001907348633 8.5 1.000001907348633 M 8.5 1.9073486328125e-06 C 13.19441986083984 1.9073486328125e-06 17 3.805581092834473 17 8.500000953674316 C 17 13.19442081451416 13.19441986083984 17 8.5 17 C 3.805580139160156 17 0 13.19442081451416 0 8.500000953674316 C 0 3.805581092834473 3.805580139160156 1.9073486328125e-06 8.5 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#6c7091"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG41Label",
    transform: "translate(16.058 1.963)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-41\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGS45",
    className: "tooltip cursorArrow ",
    transform: "translate(1146.979 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POLES-12",
    "data-name": "POLES",
    transform: "translate(0 15.652)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-12",
    "data-name": "POLES1",
    y2: 14.972,
    transform: "translate(1.354 0.681)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-10",
    "data-name": "POLES2",
    x1: 18.958,
    transform: "translate(1.354 0.681)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS45Aspect1",
    transform: "translate(20.431 8.075)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS45Aspect2",
    transform: "translate(37.524 7.287)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0A8.5,8.5,0,1,1,0,8.5,8.5,8.5,0,0,1,8.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 1.000001907348633 C 4.364489555358887 1.000001907348633 1 4.364490509033203 1 8.500000953674316 C 1 12.63551139831543 4.364489555358887 16 8.5 16 C 12.6355094909668 16 16 12.63551139831543 16 8.500000953674316 C 16 4.364490509033203 12.6355094909668 1.000001907348633 8.5 1.000001907348633 M 8.5 1.9073486328125e-06 C 13.19441986083984 1.9073486328125e-06 17 3.805581092834473 17 8.500000953674316 C 17 13.19442081451416 13.19441986083984 17 8.5 17 C 3.805580139160156 17 0 13.19442081451416 0 8.500000953674316 C 0 3.805581092834473 3.805580139160156 1.9073486328125e-06 8.5 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#6c7091"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG45Label",
    transform: "translate(18.036 3.096)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-45\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGC46",
    className: "tooltip cursorArrow ",
    transform: "translate(1272.917 37.429)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC46Label",
    transform: "translate(5.417 19.735)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-46\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC46Aspect",
    transform: "translate(9.947 9.919)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-13",
    "data-name": "POLES",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-13",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(39.271 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-11",
    "data-name": "POLES2",
    x2: 16.25,
    transform: "translate(22.936 16.247)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-10",
    "data-name": "POLES3",
    x2: 5.417,
    transform: "translate(4.995 16.678)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SG46Route",
    className: "tooltip cursorArrow ",
    transform: "translate(1221.917 50.433)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SGS46RouteBAspect",
    y1: 3.943,
    x2: 8.517,
    transform: "translate(13.209 4.251)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SGS46RouteCAspect",
    y1: 5.444,
    transform: "translate(21.623 5.517)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SGS46RouteAAspect",
    x2: 13.542,
    transform: "translate(8.125 2.722)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SGS46RouteBLabel",
    transform: "translate(5.819 12.117)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              B\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SGS46RouteCLabel",
    transform: "translate(15.428 15.686)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              C\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SGS46RouteALabel",
    transform: "translate(0.452 0.611)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              A{\" \"}\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGS46",
    className: "tooltip cursorArrow ",
    transform: "translate(1229.583 47.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect1",
    transform: "translate(31.67 -0.616)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect2",
    transform: "translate(14.582 -0.706)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG46Label",
    transform: "translate(11.936 30.417)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-46\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SGS31",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG31Signal1",
    transform: "translate(-96.93 179.136) rotate(180)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SG31Signal2",
    transform: "translate(-79.842 179.226) rotate(180)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS31Label",
    transform: "translate(-108.794 158.074)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-31\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SGC31Label",
    transform: "translate(-156.213 149.72)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\n              C-31\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SG31Calling",
    transform: "translate(-117.191 177.657) rotate(180)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SG31PoleB",
    d: "M0,.225-.055,10.549l12.7.066-.065,12.363-8.4-.044",
    transform: "translate(-126.135 194.123) rotate(180)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "SG31PoleA",
    x2: 5,
    transform: "translate(-118.157 171.212)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SG31ShuntPole",
    d: "M-.409,20.139V.628h4.02",
    transform: "translate(-55.505 174.883) rotate(0.3)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SG31ShuntA",
    transform: "translate(-51.979 170.03) rotate(0.3)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SG31ShuntB",
    transform: "translate(-40.98 170.088) rotate(0.3)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SG31ShuntC",
    transform: "translate(-29.98 170.145) rotate(0.3)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG31ShuntLabel",
    transform: "translate(-46.44 162.431) rotate(0.3)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-31\n            ")), /*#__PURE__*/React.createElement("line", {
    id: "SG31RouteAIcon",
    x2: 11,
    transform: "translate(-79.031 170.775)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SG31RouteBIcon",
    y1: 6.51,
    x2: 9.034,
    transform: "translate(-79.753 162.274)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SG31RouteLableA",
    transform: "translate(-67.554 175.32) rotate(0.3)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              A\n            ")), /*#__PURE__*/React.createElement("text", {
    id: "SG31RouteLableB",
    transform: "translate(-69.486 162.31) rotate(0.3)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              B\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "Shunt",
    transform: "translate(4.047 -103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SH219",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH219Pole1",
    y2: 14,
    transform: "translate(559 604)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH219Aspect1",
    transform: "translate(571 611)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH219Pole2",
    y1: 12,
    transform: "translate(571 617) rotate(90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH219Aspect2",
    transform: "translate(582 611)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH219Aspect3",
    transform: "translate(593 611)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH219Label",
    transform: "translate(588 635)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-219\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH217",
    className: "tooltip cursorArrow ",
    transform: "translate(634 483)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH217Pole1",
    y1: 14,
    transform: "translate(0 20)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH217Aspect1",
    transform: "translate(12 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH217Pole2",
    y2: 12,
    transform: "translate(0 21) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH217Aspect2",
    transform: "translate(23 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH217Aspect3",
    transform: "translate(34 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH217Label",
    transform: "translate(29 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-217\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH220",
    className: "tooltip cursorArrow ",
    transform: "translate(1217 189) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH220Pole1",
    y2: 17,
    transform: "translate(0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH220Aspect1",
    transform: "translate(12 11)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH220Pole2",
    y1: 12,
    transform: "translate(12 17) rotate(90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH220Aspect2",
    transform: "translate(23 11)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH220Aspect3",
    transform: "translate(34 11)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH220Label",
    transform: "translate(61 28) rotate(180)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-220\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH142",
    className: "tooltip cursorArrow ",
    transform: "translate(1228 479) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH142Pole1",
    y1: 17,
    transform: "translate(0 22)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH142Aspect1",
    transform: "translate(12 17)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH142Pole2",
    y2: 12,
    transform: "translate(0 22) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH142Aspect2",
    transform: "translate(23 17)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH142Aspect3",
    transform: "translate(34 17)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH142Label",
    transform: "translate(61 3) rotate(180)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-142\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH218",
    className: "tooltip cursorArrow ",
    transform: "translate(1132 319)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH218Pole1",
    y1: 14,
    transform: "translate(62 20)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH218Aspect1",
    transform: "translate(39 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH218Pole2",
    y1: 12,
    transform: "translate(50 21) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH218Aspect2",
    transform: "translate(28 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH218Aspect3",
    transform: "translate(17 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH218Label",
    transform: "translate(0 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-218\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH136",
    className: "tooltip cursorArrow ",
    transform: "translate(390 524)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH217Pole1-2",
    "data-name": "SH217Pole1",
    y2: 14,
    transform: "translate(62)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH217Aspect1-2",
    "data-name": "SH217Aspect1",
    transform: "translate(39 7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH217Pole2-2",
    "data-name": "SH217Pole2",
    y2: 12,
    transform: "translate(62 13) rotate(90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH217Aspect2-2",
    "data-name": "SH217Aspect2",
    transform: "translate(28 7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH217Aspect3-2",
    "data-name": "SH217Aspect3",
    transform: "translate(17 7)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH136Label",
    transform: "translate(0 31)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-136\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH134",
    className: "tooltip cursorArrow ",
    transform: "translate(178 405)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH134Pole1",
    y1: 14,
    transform: "translate(62 20)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH134Aspect1",
    transform: "translate(39 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH134Pole2",
    y1: 12,
    transform: "translate(50 21) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH134Aspect2",
    transform: "translate(28 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH134Aspect3",
    transform: "translate(17 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH134Label",
    transform: "translate(0 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-136\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH140",
    className: "tooltip cursorArrow ",
    transform: "translate(442 158)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH140Pole1",
    y1: 14,
    transform: "translate(62 20)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH140Aspect1",
    transform: "translate(39 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH140Pole2",
    y1: 12,
    transform: "translate(50 21) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH140Aspect2",
    transform: "translate(28 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH140Aspect3",
    transform: "translate(17 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH140Label",
    transform: "translate(0 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-140\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH138",
    className: "tooltip cursorArrow ",
    transform: "translate(231 323)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH138Pole1",
    y1: 14,
    transform: "translate(0 20)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH138Aspect1",
    transform: "translate(12 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH138Pole2",
    y2: 12,
    transform: "translate(0 21) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH138Aspect2",
    transform: "translate(23 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH138Aspect3",
    transform: "translate(34 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH138Label",
    transform: "translate(29 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-138\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "SH135",
    className: "tooltip cursorArrow ",
    transform: "translate(805 156)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH135Pole1",
    y1: 14,
    transform: "translate(0 20)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH135Aspect1",
    transform: "translate(12 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "SH135Pole2",
    y2: 12,
    transform: "translate(0 21) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH135Aspect2",
    transform: "translate(23 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH135Aspect3",
    transform: "translate(34 16)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "square",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH135Label",
    transform: "translate(29 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SH-135\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "Direction",
    transform: "translate(1386.466 57.527) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UP3",
    transform: "translate(42.656 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR1",
    transform: "translate(50.23 -2.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M5.784,0l5.784,12.187H0Z",
    transform: "translate(36.563 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 24.375,
    transform: "translate(0 5.785)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "UP",
    transform: "translate(23.001 8.866)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              UP\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "DN3",
    transform: "translate(0 83.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR2",
    transform: "translate(39.55 15.597) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M5.784,0l5.784,12.187H0Z",
    transform: "translate(36.563 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15-2",
    "data-name": "Line 15",
    x2: 24.375,
    transform: "translate(0 5.785)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "DN",
    transform: "translate(49.005 16.016)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              DN\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "UPMain3",
    transform: "translate(4.063 155.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR3",
    transform: "translate(97.5 2.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-3",
    "data-name": "Polygon 1",
    d: "M5.784,0l5.784,12.187H0Z",
    transform: "translate(36.563 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15-3",
    "data-name": "Line 15",
    x2: 24.375,
    transform: "translate(0 5.785)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "UP_MAIN",
    "data-name": "UP MAIN",
    transform: "translate(24.973 14.191)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              UP MAIN\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "UPMain4",
    transform: "translate(8.125 244.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR4",
    transform: "translate(36.563 14.291) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-4",
    "data-name": "Polygon 1",
    d: "M5.784,0l5.784,12.187H0Z",
    transform: "translate(36.563 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15-4",
    "data-name": "Line 15",
    x2: 24.375,
    transform: "translate(0 5.785)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "DN_MAIN",
    "data-name": "DN MAIN",
    transform: "translate(46.011 14.819)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              DN MAIN\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "Legend",
    transform: "translate(4.047 -103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegend",
    transform: "translate(1005.561 -243.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendCanvas",
    transform: "translate(221 956)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 86,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75,
    height: 84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendLabel",
    transform: "translate(227 973)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              POINT MACHINE\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormal",
    transform: "translate(227 980.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormalIndicator",
    fill: "none",
    stroke: "#21e074",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendNormalLabel",
    transform: "translate(24 11.5)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                NORMAL\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverse",
    transform: "translate(227 1001.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverseIndicator",
    fill: "none",
    stroke: "#0088d1",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendReverseLabel",
    transform: "translate(24 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                REVERSE\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendHr",
    transform: "translate(227.929 1022.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr1",
    d: "M7.4,12.277C3.421,9.825,1.334,7.6.478,5.729-1.814.728,4.734-1.664,7.4,1.288c2.665-2.953,9.214-.561,6.921,4.441C13.465,7.6,11.378,9.825,7.4,12.277Z",
    transform: "translate(0 2.421)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr2",
    d: "M-.094-.624H3.458L4.929-3.307,6.838,1.765,8.215-.624,13-.63",
    transform: "translate(0.948 9.235)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendFailureLabel",
    transform: "translate(23.702 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                FAILURE\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegend",
    transform: "translate(452.869 -300.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TCLegendCanvas",
    transform: "translate(876 1013)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 86,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 111,
    height: 84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TCLegendLabel",
    transform: "translate(886.5 1031)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              TRACK CIRCUIT\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "TCFreeLegendGroup",
    transform: "translate(886.5 1040.132)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFreeLegendIndicator",
    x2: 50,
    transform: "translate(0 5.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFreeLegendLabel",
    transform: "translate(60.5 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                FREE\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOccupiedLegendGroup",
    transform: "translate(885.539 1058.383)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOccupiedLegendIndicator",
    x2: 50,
    transform: "translate(0 5.5)",
    fill: "none",
    stroke: "#e77e00",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOccupiedLegendLabel",
    transform: "translate(59.921 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                OCCUPIED\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "TCFailureLLegendGroup",
    transform: "translate(885.54 1080.539)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFailureLegendIndicator",
    x2: 50,
    transform: "translate(0 5.5)",
    fill: "none",
    stroke: "red",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFailureLLegendLabel",
    transform: "translate(60 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                FAILURE\n              ")))), /*#__PURE__*/React.createElement("g", {
    id: "AXLIPSBASBARLegend",
    transform: "translate(1246.178 -243.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXLIPSBASBARLegendCanvas",
    transform: "translate(221 956)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 86,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75,
    height: 84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXLIPSBASBARLegendLabel",
    transform: "translate(227.929 973.785)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL/BAS BAR/IPS\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "AXLIPSBASBARLegendNormal",
    transform: "translate(227 980.823)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLIPSBASBARLegendNormalLabel",
    transform: "translate(24 11.5)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                NORMAL\n              ")), /*#__PURE__*/React.createElement("path", {
    id: "AXLIPSBASBARLegendNormalIndicator",
    d: "M2,0h9a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(1.775 2.126)",
    fill: "#21e074"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AXLIPSBASBARLegendReverse",
    transform: "translate(227 1001.861)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLIPSBASBARLegendReverseLabel",
    transform: "translate(24 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                WARNING\n              ")), /*#__PURE__*/React.createElement("path", {
    id: "AXLIPSBASBARLegendReverseIndicator",
    d: "M2,0h9a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(1.775 0.089)",
    fill: "#e77e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AXLIPSBASBARLegendFailure",
    transform: "translate(227.929 1022.551)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLIPSBASBARLegendFailureLabel",
    transform: "translate(23.702 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                FAILURE\n              ")), /*#__PURE__*/React.createElement("path", {
    id: "AXLIPSBASBARLegendFailureIndicator",
    d: "M2,0h9a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(0.846 -1.602)",
    fill: "red"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "BETTARY",
    transform: "translate(-159 -239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BMS",
    className: "cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BMSCanvas",
    width: 94,
    height: 60,
    transform: "translate(146 325)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BMSShape"
  }, /*#__PURE__*/React.createElement("line", {
    id: "BETTARYLine1",
    y2: 60,
    transform: "translate(143.5 325)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "BETTARYLine2",
    y2: 60,
    transform: "translate(241.889 325)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "BETTARYLine3",
    d: "M119.032,7V.313H13.768V7",
    transform: "translate(125.1 303.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "BETTARYLine4",
    d: "M48.278,18.461V6.621H12.266v11.84",
    transform: "translate(161.228 285.849)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "BETTARYLine5",
    d: "M7.684,18.933V11.266H0v7.667",
    transform: "translate(223.258 284.291)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "BETTARYRectangle1",
    transform: "translate(129 385)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 121,
    height: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BETTARYRectangle2",
    transform: "translate(129 311)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 121,
    height: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "BETTARYLable1",
    d: "M7.68,18.933V11.266H0v7.667",
    transform: "translate(149.734 284.291)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "BETTARYPOWER",
    d: "M72.342.39A.511.511,0,0,0,71.9,0h-7.22c-.218,0-.411.212-.473.518L61.631,13.172a1,1,0,0,0,.077.638.466.466,0,0,0,.4.29h4.048L64.522,26.064a.82.82,0,0,0,.312.82.359.359,0,0,0,.173.046.5.5,0,0,0,.429-.365L71.8,10.212a1.025,1.025,0,0,0,0-.723.5.5,0,0,0-.427-.361H68.5l3.806-7.991A1.012,1.012,0,0,0,72.342.39Z",
    transform: "translate(122.326 342.789) rotate(-3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BETTARYPLUS",
    transform: "translate(-1.807 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "BETTARYPLUSLine2",
    y2: 10,
    transform: "translate(160.5 333)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "BETTARYPLUSLine1",
    x1: 10,
    transform: "translate(155.5 338)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "BETTARYMINUSLine1",
    x1: 10,
    transform: "translate(218.258 339)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Stationinfo",
    transform: "translate(-4491.808 -223)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Canvas-StationInfo",
    transform: "translate(5250.058 22)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "NirmalaUI, Nirmala UI",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -58.66,
    y: 0
  }, "\n            \u0932\u0916\u0940\u0938\u0930\u093E\u092F\n          ")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H180",
    transform: "translate(5170.808 39.216)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "Canvas-StationInfo-2",
    "data-name": "Canvas-StationInfo",
    transform: "translate(5260.808 80.431)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -80.801,
    y: 0
  }, "\n            LAKHISARAI\n          "))), /*#__PURE__*/React.createElement("g", {
    id: "IPS",
    transform: "translate(-16 61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSEXTERNAL",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSEXTERNALIcon",
    transform: "translate(-47 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSEXTERNALLable",
    transform: "translate(-42 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              EXT\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSINTERNAL",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSINTERNALIcon",
    transform: "translate(8 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSNTERNALLable",
    transform: "translate(20 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              INT\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL9B",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL9BLable",
    transform: "translate(67 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL9B\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL9BIcon",
    transform: "translate(63 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL9A",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL9AIcon",
    transform: "translate(118 -99)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL9ALable",
    transform: "translate(118 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL9A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL10B",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL10BIcon",
    transform: "translate(173 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL10BLable",
    transform: "translate(173 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL10B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL11A",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL11AIcon",
    transform: "translate(228 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL11ALable",
    transform: "translate(228 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL11A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL11B",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL11BIcon",
    transform: "translate(283 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL11BLable",
    transform: "translate(287 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL11B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL10A",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL10AIcon",
    transform: "translate(338 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL10ALable",
    transform: "translate(342 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL10A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL7B",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL7BIcon",
    transform: "translate(393 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL7BLable",
    transform: "translate(397 -108)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL7B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL7A",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL7AIcon",
    transform: "translate(448 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL7ALable",
    transform: "translate(455 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL7A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL8B",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL8BIcon",
    transform: "translate(503 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL8BLable",
    transform: "translate(507 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL8B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL8A",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSAXL8AIcon",
    transform: "translate(558 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSAXL8ALable",
    transform: "translate(562 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              AXL8A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSEISTBY",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSEISTBYIcon",
    transform: "translate(613 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSISTBYLable",
    transform: "translate(617 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              EISTBY\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSPOWER_INPUT",
    className: "tooltip cursorArrow ",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSPOWER_INPUTIcon",
    transform: "translate(668 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSOWER_INPUTLable",
    transform: "translate(672 -107)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              PW-IP\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSEIMAIN",
    className: "tooltip cursorArrow ",
    transform: "translate(19 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSEIMAINIcon",
    transform: "translate(898 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSIMAINLable",
    transform: "translate(898 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              EIMAIN\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSDL",
    className: "tooltip cursorArrow ",
    transform: "translate(27 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSDLIcon",
    transform: "translate(953 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSLLable",
    transform: "translate(960 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              DL\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSMCP",
    className: "tooltip cursorArrow ",
    transform: "translate(32 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSMCPIcon",
    transform: "translate(1008 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSCPLable",
    transform: "translate(1012 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              MCP\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPESKT",
    className: "tooltip cursorArrow ",
    transform: "translate(39 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSEKTIcon",
    transform: "translate(1063 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSKTLable",
    transform: "translate(1070 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              EKT\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSTRACK_DN",
    className: "tooltip cursorArrow ",
    transform: "translate(-11 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSTRACK_DNIcon",
    transform: "translate(1173 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSRACK_DNLable",
    transform: "translate(1177 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              TR-DN\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSTRACK_UP",
    className: "tooltip cursorArrow ",
    transform: "translate(-4 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSTRACK_UPIcon",
    transform: "translate(1228 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSRACK_UPLable",
    transform: "translate(1232 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              TR-UP\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_UP_2",
    className: "tooltip cursorArrow ",
    transform: "translate(1 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_UP_2Icon",
    transform: "translate(1283 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSIGNAL_UP_2Lable",
    transform: "translate(1283 -108)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SG-UP2\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_UP_1",
    className: "tooltip cursorArrow ",
    transform: "translate(1 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_UP_1Icon",
    transform: "translate(1338 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSIGNAL_UP_1Lable",
    transform: "translate(1338 -108)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SG-UP1\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_DN_2",
    className: "tooltip cursorArrow ",
    transform: "translate(8 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_DN_2Icon",
    transform: "translate(1389 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSIGNAL_DN_2Lable",
    transform: "translate(1392 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SG-DN2\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_DN_1",
    className: "tooltip cursorArrow ",
    transform: "translate(8 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSSIGNAL_DN_1Icon",
    transform: "translate(1448 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSIGNAL_DN_1Lable",
    transform: "translate(1447 -108)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              SG-DN1\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSPOINT_OUTPUT",
    className: "tooltip cursorArrow ",
    transform: "translate(8 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IPSPOINT_OUTPUTIcon",
    transform: "translate(1503 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSOINT_OUTPUTLable",
    transform: "translate(1507 -109)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              P-OP\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "IPSBATTERY_INPUT",
    className: "tooltip cursorArrow ",
    transform: "translate(8 16)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "IPSBATTERY_INPUTLable",
    transform: "translate(1548 -108)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              BATTERY-IP\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "IPSBATTERY_INPUTIcon",
    transform: "translate(1558 -101)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IPSShape"
  }, /*#__PURE__*/React.createElement("line", {
    id: "IPSLine4",
    x2: 760,
    y2: 4,
    transform: "translate(-45 -51)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "IPSLine3",
    x2: 760,
    y2: 4,
    transform: "translate(-45 -47)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "IPSLine2",
    x2: 722,
    transform: "translate(894 -47)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "IPSLine1",
    x2: 722,
    transform: "translate(894 -43)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "IPSRectangle",
    transform: "translate(715 -118)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 176,
    height: 73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IPSlable",
    transform: "translate(769 -61)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              IPS\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "Axle",
    transform: "translate(41 -42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL10Rectangle",
    className: "tooltip cursorArrow ",
    transform: "translate(888 473)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AXL7A",
    className: "tooltip cursorArrow ",
    transform: "translate(3 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL7AIcon",
    transform: "translate(903 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL7ALable",
    transform: "translate(904 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              7A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL7B",
    className: "tooltip cursorArrow ",
    transform: "translate(0 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL7BIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL7BLable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              7B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL11Rectangle",
    className: "tooltip cursorArrow ",
    transform: "translate(1033 473)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AXL8A",
    className: "tooltip cursorArrow ",
    transform: "translate(150 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL8AIcon",
    transform: "translate(903 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL10ALable",
    transform: "translate(904 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              8A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL8B",
    className: "tooltip cursorArrow ",
    transform: "translate(147 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL8BIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL8BLable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              8B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL9Rectangle",
    className: "tooltip cursorArrow ",
    transform: "translate(1178 473)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AXL9A",
    className: "tooltip cursorArrow ",
    transform: "translate(245 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL9AIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL9ALable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              9A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL9B",
    className: "tooltip cursorArrow ",
    transform: "translate(288 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL9BIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL9BLable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              9B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL8Rectangle",
    className: "tooltip cursorArrow ",
    transform: "translate(1323 473)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AXL10A",
    className: "tooltip cursorArrow ",
    transform: "translate(391 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL10AIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL10ALable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              10A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL10B",
    className: "tooltip cursorArrow ",
    transform: "translate(434 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL10BIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL10BLable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              10B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL7Rectangle",
    className: "tooltip cursorArrow ",
    transform: "translate(1468 475)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AXL11A",
    className: "tooltip cursorArrow ",
    transform: "translate(535 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL11AIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL11ALable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              11A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "AXL11B",
    className: "tooltip cursorArrow ",
    transform: "translate(578 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXL11BIcon",
    transform: "translate(949 508)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AXL11BLable",
    transform: "translate(951 542)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              11B\n            "))), /*#__PURE__*/React.createElement("text", {
    id: "Axle_Counter",
    "data-name": "Axle Counter",
    transform: "translate(1145 550)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "\n            Axle Counter\n          "))), /*#__PURE__*/React.createElement("g", {
    id: "Bus_Bar",
    transform: "translate(-104 -260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BBLItem"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BBGayaRoute",
    d: "M0,36,49.243-.446,412,0",
    transform: "translate(675.5 896.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "BBPatnaRoute",
    d: "M0-.946,49.923,30.67,525,31.054",
    transform: "translate(675.5 932.946)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "BBKiulRoute",
    d: "M0,0,600,.5",
    transform: "translate(85 932)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "DR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR1KIUL"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR1-2",
    "data-name": "DR1",
    transform: "translate(2268.25 1192) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DR1Polygon",
    d: "M8,0l8,11.735H0Z",
    transform: "translate(2092.917 196.5) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "DR1Line",
    x2: 45.432,
    transform: "translate(2035.75 204.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "DR1KIULLable",
    transform: "translate(243 994)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                  KIUL\n                "))), /*#__PURE__*/React.createElement("g", {
    id: "DR2GAYA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR2-2",
    "data-name": "DR2",
    transform: "translate(851.416 844.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DR2Polygon",
    d: "M8,0l8,11.735H0Z",
    transform: "translate(57.167 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "DR2Line",
    x2: 45.432,
    transform: "translate(0 8)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "DR2GAYALable",
    transform: "translate(802 859)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                  GAYA\n                "))), /*#__PURE__*/React.createElement("g", {
    id: "DR3PATNA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DR3-2",
    "data-name": "DR3",
    transform: "translate(1036.833 1007.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DR3Polygon",
    d: "M8,0l8,11.735H0Z",
    transform: "translate(57.167 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "DR3Line",
    x2: 45.432,
    transform: "translate(0 8)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "DR3PATNALable",
    transform: "translate(983 1022)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                  PATNA\n                ")))), /*#__PURE__*/React.createElement("g", {
    id: "BASBARVOLTAGEIcon"
  }, /*#__PURE__*/React.createElement("text", {
    id: "BASBARVOLTAGELable",
    transform: "translate(379 1013)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                BUS BAR VOLTAGE\n              ")), /*#__PURE__*/React.createElement("line", {
    id: "BASBARVOLTAGELine",
    x2: 189,
    transform: "translate(379.5 1026.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "BasBarRectangle",
    transform: "translate(54 832)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1223,
    height: 239,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1221,
    height: 237,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "BBL163",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL163Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(85 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB163Lable",
    transform: "translate(62 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-163\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL168",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL168Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(125 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB168Lable",
    transform: "translate(102 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-168\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL169",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL169Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(165 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB169Lable",
    transform: "translate(142 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-169\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL171",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL171Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(245 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB171Lable",
    transform: "translate(222 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-171\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL173",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL173Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(325 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB173Lable",
    transform: "translate(302 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-173\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL175",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL175Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(405 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB175Lable",
    transform: "translate(382 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-175\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL178",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL178Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(485 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB178Lable",
    transform: "translate(462 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-178\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL180",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL180Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(565 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB180Lable",
    transform: "translate(542 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-180\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL183",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL183Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(645 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB183Lable",
    transform: "translate(622 899)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-183\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL185",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL185Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(685 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB185Lable",
    transform: "translate(662 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-185\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL170",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL170Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(205 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB170Lable",
    transform: "translate(182 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-170\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL172",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL172Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(285 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB172Lable",
    transform: "translate(262 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-172\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL174",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL174Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(365 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB174Lable",
    transform: "translate(342 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-174\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL177",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL177Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(445 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB177Lable",
    transform: "translate(422 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-177\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL179",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL179Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(525 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB179Lable",
    transform: "translate(502 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-179\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL182",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL182Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(605 921) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB182Lable",
    transform: "translate(582 949)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-182\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL189",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL189Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(757 955) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB189Lable",
    transform: "translate(734 983)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-189\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL189A",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL189AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(797 955) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BBL189ALable",
    transform: "translate(774 935)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-189A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL189B",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL189BIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(837 955) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB189BLable",
    transform: "translate(814 983)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-189B\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL195",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL195Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(877 955) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB195Lable",
    transform: "translate(854 935)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-195\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL198",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL198Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(957 955) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB198Lable",
    transform: "translate(934 935)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-198\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL199",
    className: "tooltip cursorArrow ",
    transform: "translate(974 955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL199Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(3 20) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB199Lable",
    transform: "translate(0 28)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-199\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL201",
    className: "tooltip cursorArrow ",
    transform: "translate(1054 955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL201Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(3 20) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB201Lable",
    transform: "translate(0 26)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-201\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL203A",
    className: "tooltip cursorArrow ",
    transform: "translate(1134 954)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL203AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(3 20) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB203ALable",
    transform: "translate(0 26)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-203A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL197",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL197Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(917 955) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB197Lable",
    transform: "translate(894 983)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-197\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL200",
    className: "tooltip cursorArrow ",
    transform: "translate(1014 935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL200Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(3 40) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB200Lable",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-200\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL202",
    className: "tooltip cursorArrow ",
    transform: "translate(1094 933)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL202Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(3 42) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB202Lable",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-202\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL203",
    className: "tooltip cursorArrow ",
    transform: "translate(1180 933)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL203Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(4 42) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BBL203Lable",
    transform: "translate(-4)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-203\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL190",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL190Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(737 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB190Lable",
    transform: "translate(714 910)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-190\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL207A",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL207AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(817 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB207ALable",
    transform: "translate(794 910)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-207A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL210A",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL210AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(897 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB210ALable",
    transform: "translate(874 910)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-210A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL211A",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL211AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(977 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB211ALable",
    transform: "translate(954 910)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-211A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL213",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL213Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(1057 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB213Lable",
    transform: "translate(1034 910)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-213\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL213A",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL213AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(1097 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB213ALable",
    transform: "translate(1071 867)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-213A\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL212",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL212Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(1017 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB212Lable",
    transform: "translate(994 867)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-212\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL211",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL211Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(937 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB211Lable",
    transform: "translate(914 867)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-211\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL210",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL210Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(857 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB210Lable",
    transform: "translate(834 867)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-210\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "BBL207",
    className: "tooltip cursorArrow "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BBL207Icon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(777 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BB207Lable",
    transform: "translate(754 867)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n              L-207\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(-100 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangl 1",
    transform: "translate(29 34)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 108,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 256,
    height: 107,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bitcomm_logo",
    transform: "translate(-1047.417 -282.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitcomm_logo-2",
    "data-name": "Bitcomm_logo",
    transform: "translate(1097.5 333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(35.597 0.608) rotate(45)",
    fill: "#0e86d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50.90496444702148 50.90496444702148 L 1.887659072875977 49.62485504150391 L 0.6075512766838074 0.6075512766838074 L 49.62485504150391 1.887659072875977 L 50.90496444702148 50.90496444702148 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.121135711669922 1.121135711669922 L 2.375099182128906 49.13741683959961 L 50.39138031005859 50.39138031005859 L 49.13741683959961 2.375099182128906 L 1.121135711669922 1.121135711669922 M 0.09396743774414062 0.09396743774414062 L 50.11229705810547 1.400218963623047 L 51.41854858398438 51.41854858398438 L 1.400218963623047 50.11229705810547 L 0.09396743774414062 0.09396743774414062 Z",
    stroke: "none",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(19.204 19.74)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 17.799,
    ry: 18.753,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 15.299,
    ry: 16.253,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M.568-1.031h0s8.95,7.449,10.283,9.924a47.609,47.609,0,0,1,2.316,5.086",
    transform: "translate(9.332 30.117)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(16.001 22.307) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M.143,5.135.455.013l14.3.812,2.286,4.348L15.152,5.2Z",
    transform: "translate(0.54 0.509)",
    fill: "#0e86d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1.448,1.027,1.2,5.165l14.469.058L16.8,5.209,15,1.8,1.448,1.027M.542.015,15.58.869l2.778,5.284-2.639.033L.171,6.123Z",
    transform: "translate(0 0)",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3",
    transform: "matrix(0.616, -0.788, 0.788, 0.616, 7.56, 30.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M3.893.459-.014.5,0,0,3.893.366Z",
    transform: "translate(0.473 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M.013,0,4.85.455v1l-4.892.051Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M44,44",
    transform: "translate(-3.719 31.506)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 1.481)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 31.584)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 26.649)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(9.368 21.714)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(69.789) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571 0)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-2",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(70.258 73.532) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-3",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 27.636)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-3",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(8.431 22.701)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-3",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-3",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-3",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-3",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-3",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(34.192 37.506) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-4",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-4",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-4",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-4",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-3",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-4",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571 0)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-4",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-4",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(1201.95 360.974)",
    fill: "#0e86d4",
    fontSize: 24,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 140.516,
    transform: "translate(1173.378 368.039)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 140.516,
    transform: "translate(1173.378 385.805)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "T-2",
    "data-name": "T",
    transform: "translate(1171.036 381.545)",
    fill: "#0e86d4",
    fontSize: 13,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(1182.278 381.545)",
    fill: "#0e86d4",
    fontSize: 13,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "C",
    transform: "translate(1193.519 380.545)",
    fill: "#0e86d4",
    fontSize: 12,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "H",
    transform: "translate(1205.697 380.545)",
    fill: "#0e86d4",
    fontSize: 12,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "N",
    transform: "translate(1219.749 379.545)",
    fill: "#0e86d4",
    fontSize: 11,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "translate(1233.8 379.545)",
    fill: "#0e86d4",
    fontSize: 11,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(1247.852 380.545)",
    fill: "#0e86d4",
    fontSize: 12,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "O-2",
    "data-name": "O",
    transform: "translate(1258.156 379.545)",
    fill: "#0e86d4",
    fontSize: 11,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "G",
    transform: "translate(1272.208 380.545)",
    fill: "#0e86d4",
    fontSize: 12,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G")), /*#__PURE__*/React.createElement("text", {
    id: "I",
    transform: "translate(1286.259 380.545)",
    fill: "#0e86d4",
    fontSize: 12,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "E-2",
    "data-name": "E",
    transform: "translate(1294.69 381.545)",
    fill: "#0e86d4",
    fontSize: 13,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(1305.932 381.545)",
    fill: "#0e86d4",
    fontSize: 13,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "I-2",
    "data-name": "I",
    transform: "translate(1191.646 362.974)",
    fill: "#0e86d4",
    fontSize: 26,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "B",
    transform: "translate(1172.91 361.974)",
    fill: "#0e86d4",
    fontSize: 25,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B")), /*#__PURE__*/React.createElement("text", {
    id: "O-3",
    "data-name": "O",
    transform: "translate(1239.421 359.974)",
    fill: "#0e86d4",
    fontSize: 23,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "C-2",
    "data-name": "C",
    transform: "translate(1219.749 360.974)",
    fill: "#0e86d4",
    fontSize: 24,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(1287.196 359.987)",
    fill: "#0e86d4",
    fontSize: 24,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "M-2",
    "data-name": "M",
    transform: "translate(1261.903 359.987)",
    fill: "#0e86d4",
    fontSize: 24,
    fontFamily: "MicrosoftJhengHeiRegular, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkrStation);
export default __webpack_public_path__ + "static/media/LKR_Station.fca91e3e1fa5f38b0efde97d59a17910.svg";
export { ForwardRef as ReactComponent };